import React from "react";

const WarningIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="warning_icon"
      data-name="warning"
      {...props}
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.96859 1.33334C4.30992 1.33334 1.33325 4.32401 1.33325 8.00001C1.33325 11.676 4.32392 14.6667 7.99992 14.6667C11.6759 14.6667 14.6666 11.676 14.6666 8.00001C14.6666 4.32401 11.6619 1.33334 7.96859 1.33334ZM7.99992 13.3333C5.05925 13.3333 2.66659 10.9407 2.66659 8.00001C2.66659 5.05934 5.04459 2.66668 7.96859 2.66668C10.9273 2.66668 13.3333 5.05934 13.3333 8.00001C13.3333 10.9407 10.9406 13.3333 7.99992 13.3333Z"
        fill={props.fill || "#B9CED5"}
      />
      <path
        d="M7.33325 4.66666H8.66659V9.33332H7.33325V4.66666ZM7.33325 9.99999H8.66659V11.3333H7.33325V9.99999Z"
        fill={props.fill || "#B9CED5"}
      />
    </svg>
  );
};

export default WarningIcon;
